import { useEffect } from 'react';
import { format } from '@react-input/mask';
import { UseFormSetValue } from 'react-hook-form';
import { DataFromEsia, FormValues } from 'pages/questionnaire/types';
import { documentNumberMaskOptions, documentSerialMaskOptions, innMaskOptions, phoneMaskOptions } from 'shared/lib';

export const useUpdateFromEsia = (setValue: UseFormSetValue<FormValues>, dataFromEsia?: DataFromEsia) => {
  useEffect(() => {
    if (!dataFromEsia) {
      return;
    }

    setValue('lastName', dataFromEsia.lastName || '');
    setValue('firstName', dataFromEsia.firstName || '');
    setValue('middleNameField.middleName', dataFromEsia.middleName || '');
    setValue('middleNameField.doesntExist', dataFromEsia.middleNameDoesntExist || false);
    setValue('birthDate', dataFromEsia.birthDate || '');
    setValue('birthPlace', dataFromEsia.birthPlace || '');
    setValue(
      'documentSerial',
      dataFromEsia.documentSerial ? format(dataFromEsia.documentSerial, documentSerialMaskOptions) : '',
    );
    setValue(
      'documentNumber',
      dataFromEsia.documentNumber ? format(dataFromEsia.documentNumber, documentNumberMaskOptions) : '',
    );
    setValue('documentIssuedBy', dataFromEsia.documentIssuedBy || '');
    setValue('documentIssueDate', dataFromEsia.documentIssueDate || '');
    setValue('addressReg', dataFromEsia.addressReg || '');
    setValue('addressFactField.addressFact', dataFromEsia.addressFact || '');
    setValue('INN', dataFromEsia.INN ? format(dataFromEsia.INN, innMaskOptions) : '');
    setValue(
      'phoneMobile',
      dataFromEsia.phoneMobile ? format(dataFromEsia.phoneMobile.replace(/^((\+?7)|8)/, ''), phoneMaskOptions) : '',
    );
    setValue('isGosuslugi', true);

    if (dataFromEsia.addressFact && dataFromEsia.addressReg) {
      setValue('addressFactField.same', dataFromEsia.addressFact === dataFromEsia.addressReg);
    }
  }, [dataFromEsia, setValue]);
};
